import React from 'react';

import type { InputElement } from '../input';
import Icon, { IconList } from '../icon';
import Input from '../input';
import Html from '../html';

import styles from './input-password.module.scss';

type InputPasswordElement = Omit<InputElement, 'type' | 'suffix'>;

const InputPassword: React.FunctionComponent<InputPasswordElement> = (props) => {
  const { testId, ...rest } = props;
  const [inputType, setInputType] = React.useState<'text' | 'password'>('password');

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();

      setInputType((prev) => (prev === 'password' ? 'text' : 'password'));
    },
    [setInputType]
  );

  const renderSuffix = React.useCallback(
    (): React.ReactNode => (
      <Html.button
        type="button"
        onClick={handleClick}
        className={styles.suffix}
        testId={testId && `${testId}-visibility`}
      >
        <Icon
          name={inputType === 'password' ? IconList.eyeOnOutline : IconList.eyeOffOutline}
          testId={testId && `${testId}-icon`}
          className={inputType === 'password' ? styles.iconOn : styles.iconOff}
        />
      </Html.button>
    ),
    [inputType, handleClick, testId]
  );

  return <Input {...rest} type={inputType} suffix={renderSuffix} testId={testId} />;
};

export type { InputPasswordElement };
export default InputPassword;
